




























































































































































import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Etat, getEtatSpec } from '@/types/DossierAdministratif'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VuePdfApp from 'vue-pdf-app'
import { base64ToArrayBuffer } from '@/utils/helpers'
import { Ability } from '@/types/Ability'
import ErrorDisplay from '@/components/ErrorDisplay.vue'

@Component({
    computed: {
        ...mapGetters('ordremission', ['error', 'ordreMissionSelect', 'save_finish', 'source_pdf', 'error']),
        ...mapState('ordremission', ['error', 'ordreMissionSelect', 'save_finish', 'source_pdf', 'error']),
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA'])
    },
    methods: {
        ...mapActions('ordremission', ['getOrdreMissions', 'getDocumentOrdreMission', 'updateOrdreMission']),
        ...mapMutations('dossieradministratif', ['MAJ_ORDRE_MISSION'])
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        VuePdfApp,
        ErrorDisplay
    }
})
export default class GestionOrdreMission extends Vue {
    @Prop() showPopup?: boolean

    Ability = Ability
    modePreviewDocument = false
    decision_ordremission: any = null
    formData = new FormData()
    libelle_document = ''
    commentaire_refus = ''
    Etat = Etat
    getEtatSpec = getEtatSpec
    config = {
        toolbar: {
            toolbarViewerRight: { presentationMode: false, openFile: false, viewBookmark: false, secondaryToolbarToggle: false }
        }
    }

    source_doc: any = ''

    // Selectionne un fichier
    selectFile (e: Event) {
        if (e.target !== null) {
            const target = e.target as HTMLInputElement
            const file: File = (target.files as FileList)[0]
            this.formData.set('document', file)
        }
    }

    // Affiche les pièces jointes à l'ordre de mission au format PDF
    showDocument (document: string) {
        const document_select = this.$store.state.ordremission.ordreMissionSelect.documents.filter((d: any) => d.name === document)
        if (document_select[0]) {
            // Appel du pdf
            this.$store.dispatch('ordremission/getDocumentOrdreMission', { ordremission_id: this.$store.state.ordremission.ordreMissionSelect.id, document_id: document_select[0].id }).then(() => {
                this.libelle_document = document_select[0].name
                this.source_doc = ''
                this.source_doc = base64ToArrayBuffer(this.$store.state.ordremission.source_pdf)
                this.modePreviewDocument = true
            })
        }
    }

    // Enregistre la décision pour l'ordre de mission
    saveDecision () {
        this.$store.state.ordremission.error = null
        if (this.decision_ordremission === Etat.ETAT_VALIDE) {
            this.formData.set('etat', this.decision_ordremission.toString())
        }
        // if (this.decision_ordremission === Etat.ETAT_REJETE) {
        if (this.decision_ordremission === Etat.ETAT_REJETE || this.decision_ordremission === Etat.ETAT_VIERGE) {
            this.formData.set('etat', this.decision_ordremission.toString())
            this.formData.set('commentaire_rejet', this.commentaire_refus)
        }

        if (this.decision_ordremission !== null) {
            this.formData.set('_method', 'PUT')
            this.$store.dispatch('ordremission/updateOrdreMission', { ordremission_id: this.$store.state.ordremission.ordreMissionSelect.id, payload: this.formData }).then((response) => {
                this.$store.commit('dossieradministratif/MAJ_ORDRE_MISSION', { dossier_id: this.$store.state.ordremission.ordreMissionSelect.dossier_administratif_id, ordre_mission: response.data.data })
                const idSucces = 't_succes_' + Math.random()
                const succesToaster = {
                    id: idSucces,
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                    noCloseButton: true,
                    fade: true,
                    autoHideDelay: 3000
                }
                this.$bvToast.toast('Enregistrement terminé !', succesToaster)
                this.$emit('reset')

                this.commentaire_refus = ''
                this.decision_ordremission = null
            }).catch((error) => {
                console.log(error)
            })
        }
    }

    // Ferme la preview d'un document
    backDocument () {
        this.modePreviewDocument = false
    }

    // Close la modif de l'ordre de mission
    closeOrdreMission () {
        this.$emit('reset')
        this.commentaire_refus = ''
        this.decision_ordremission = null
    }
}
